import type { KeyboardEvent } from "react";

export const preventEnterSubmit = (event: KeyboardEvent<HTMLFormElement>) => {
  if (event.key === "Enter" && event.target instanceof HTMLInputElement) {
    event.preventDefault();
  }
};
